import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subscription, fromEvent, timer } from 'rxjs';
import { delay, share, switchMap, take, takeUntil, tap } from 'rxjs/operators';

@Directive({ selector: '[adsptDelayedHover]' })
export class DelayedHoverDirective implements AfterViewInit, OnDestroy {
  @Output() adsptDelayedHover: EventEmitter<boolean> = new EventEmitter();
  @Input() delayTime: number = 200;
  private subs$: Subscription[] = [];
  private el: Element;

  constructor(elRef: ElementRef) {
    this.el = elRef.nativeElement;
  }

  ngAfterViewInit() {
    const mouseLeave$ = fromEvent(this.el, 'mouseleave', { passive: true }).pipe(share());

    this.subs$.push(
      fromEvent(this.el, 'mouseenter', { passive: true })
        .pipe(
          switchMap(() =>
            timer(this.delayTime).pipe(
              tap(() => this.adsptDelayedHover.emit(true)),
              switchMap(() =>
                mouseLeave$.pipe(
                  tap(() => this.adsptDelayedHover.emit(false)),
                  take(1),
                ),
              ),
              takeUntil(mouseLeave$.pipe(delay(1))),
            ),
          ),
        )
        .subscribe(),
    );
  }

  ngOnDestroy() {
    this.subs$.forEach((d) => d?.unsubscribe());
  }
}
